import { render } from "./dues-modal.vue?vue&type=template&id=5bcc47fa&scoped=true"
import script from "./dues-modal.vue?vue&type=script&lang=js"
export * from "./dues-modal.vue?vue&type=script&lang=js"

import "./dues-modal.vue?vue&type=style&index=0&id=5bcc47fa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bcc47fa"]])

export default __exports__